var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextblock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#textblock_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.911 18.08c.352 0 .519-.141.65-.502l1.328-3.542h5.458l1.327 3.542c.132.36.299.501.641.501.352 0 .58-.21.58-.554 0-.114-.026-.22-.07-.36L8.448 5.713c-.15-.396-.413-.598-.826-.598s-.685.202-.826.598L2.419 17.165c-.044.15-.07.255-.07.37 0 .333.22.544.562.544zm2.312-5.063l2.364-6.372h.053l2.364 6.372H5.223zm12.91 5.115c1.618 0 2.857-.826 3.376-2.25h.044v1.705c0 .352.22.571.545.571.325 0 .545-.22.545-.58V8.833c0-.36-.22-.589-.545-.589-.325 0-.545.229-.545.589v1.714h-.044c-.51-1.406-1.81-2.294-3.375-2.294-2.4 0-4.026 1.995-4.026 4.94 0 2.961 1.626 4.939 4.026 4.939zm.247-.976c-1.89 0-3.12-1.555-3.12-3.964 0-2.399 1.23-3.955 3.12-3.955 1.88 0 3.146 1.617 3.146 3.99 0 2.382-1.239 3.93-3.146 3.93z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "textblock_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}

export default __webpack_public_path__ + "static/media/textblock.43c5ed2a.svg";
export { SvgTextblock as ReactComponent };